import Axios from 'axios';
import { backend, dev, isProd } from '../assets/config.json';

export const isDev = process.env.NODE_ENV === 'development';
export const server = isDev && !isProd ? dev : backend;
const axios = Axios.create({
	baseURL: server
});

export default axios;